import React from 'react';
import * as styles from './StudiesTimedOutMessage.module.scss';
import { Message } from 'components/core';
import { Inline } from 'components/layout';

type Props = {
  message: string;
};

// Shown in place of the study list / search results when the underlying
// search times out, so the page doesn't show an empty state or results.
export const StudiesTimedOutMessage = ({ message }: Props) => (
  <Inline className={styles.Wrapper}>
    <Message
      type="danger"
      role="alert"
      dismissible={false}
      className={styles.Message}
    >
      {message}
    </Message>
  </Inline>
);
